import Loader from 'components/Loader'
import { useState } from 'react'

interface BankLoginCardProps {
  handleLoginBank: (username: string) => void
  loading: boolean
}

const BankLoginCard = ({ handleLoginBank, loading }: BankLoginCardProps) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const login = (e: React.FormEvent) => {
    e.preventDefault()
    if (username !== '') {
      handleLoginBank(username)
    }
  }

  return (
    <div className="card p-8">
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-2xl gradient-primary flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h2 className="heading-3">Welcome back</h2>
        <p className="text-neutral-500 mt-1">Sign in to your account</p>
      </div>

      <form onSubmit={login} className="space-y-4">
        <div>
          <label className="label">Username</label>
          <input
            type="text"
            className="input"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.currentTarget.value)}
            autoComplete="username"
          />
        </div>
        <div>
          <label className="label">Password</label>
          <input
            type="password"
            className="input"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.currentTarget.value)}
            autoComplete="current-password"
          />
        </div>

        <div className="flex items-center justify-between text-sm">
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" className="w-4 h-4 rounded border-neutral-300 text-primary-500 focus:ring-primary-500" />
            <span className="text-neutral-600">Remember me</span>
          </label>
          <a href="#" className="text-primary-600 hover:text-primary-700 font-medium">
            Forgot password?
          </a>
        </div>

        <button
          type="submit"
          className="btn-primary btn-lg w-full mt-6"
          disabled={loading || !username}
        >
          {loading ? <Loader /> : 'Sign in'}
        </button>
      </form>

      <div className="mt-6 text-center">
        <p className="text-neutral-500 text-sm">
          Don't have an account?{' '}
          <a href="#" className="text-primary-600 hover:text-primary-700 font-medium">
            Sign up free
          </a>
        </p>
      </div>

      <div className="mt-8 pt-6 border-t border-neutral-200">
        <p className="text-center text-xs text-neutral-400">
          Powered by Xave's FX Pool
        </p>
      </div>
    </div>
  )
}

export default BankLoginCard
